import { linkedSignal, signal, Signal, Type } from '@angular/core';

export abstract class AddOn<T> {
  private _hostParams = signal<T | null>(null);
  hostParams = this._hostParams.asReadonly()
  onAttach(params: T): void {
    this._hostParams.set(params);
  }
  onDetach(params: T): void {
    this._hostParams.set(null);
  }
}
